import React from 'react';

import css from './map-view.module.css';

const NICE = [1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1000];
const MAX_WIDTH = 140;

export function milesText(miles: number): string {
	const n = Math.abs(Math.round(miles));
	const tail = n % 100;
	const last = n % 10;
	const word = tail >= 11 && tail <= 14 ? 'миль' : last === 1 ? 'миля' : last >= 2 && last <= 4 ? 'мили' : 'миль';
	return `${n} ${word}`;
}

type Props = {
	/** сколько экранных пикселей в одной миле при текущем масштабе */
	pixelsPerMile: number;
};

export const MapScale: React.FC<Props> = ({pixelsPerMile}) => {
	const miles = [...NICE].reverse().find((value) => value * pixelsPerMile <= MAX_WIDTH) ?? NICE[0];
	const width = miles * pixelsPerMile;

	return (
		<div className={css.scale} aria-label={`Масштаб: ${milesText(miles)}`}>
			<div className={css.scaleBar} style={{width: `${width}px`}} />
			<span>{milesText(miles)}</span>
		</div>
	);
};
